import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Carousel component displays a slider using the react-slick library.
 *
 * @component
 * @param {Object} props - The properties for the Carousel component.
 * @param {Object} props.config - Configuration settings for the Slider component.
 * @returns {JSX.Element} The rendered Carousel component.
 */
const Carousel = (props) => <Slider {...props.config}>{props.children}</Slider>;
export default Carousel;
